























































import {tournamentsApi} from '@/api/TournamentsApi';
import {filterMatchColumns} from '@/helpers';
import {asyncScheduler, from, combineLatest, of} from 'rxjs';
import {switchMap, shareReplay} from 'rxjs/operators';
import {Component, Prop, Vue} from 'vue-property-decorator';
import ColorButton from '@/components/common/ColorButton.vue';
import DataFilter from '@/components/common/DataFilter.vue';
import BlankLoader from '@/components/common/BlankLoader.vue';
import DataTable from '@/components/common/DataTable.vue';
import CollapsibleTable from '@/components/common/CollapsibleTable.vue';
import {
  generateLangSubscriptions,
  observeFieldAsUIInput,
  observeProp,
  watchAsLoadedObservable,
} from '@/components/observe';

@Component<TournamentReports>({
  components: {
    BlankLoader,
    DataTable,
    CollapsibleTable,
    ColorButton,
    DataFilter,
  },
  subscriptions() {
    const lang$ = observeProp<string>(this, 'lang');
    const tournament$ = observeProp<number>(this, 'tournament');
    const reports$ = tournament$.pipe(
      switchMap((tournament) => from(tournamentsApi.getTournamentReports(tournament), asyncScheduler)),
      shareReplay(1),
    );
    const reportsFilter$ = observeFieldAsUIInput(this, 'reportsFilter');

    return Object.assign(generateLangSubscriptions(lang$), {
      reports: combineLatest(
        reports$,
        reportsFilter$,
      ).pipe(
        switchMap(([reports, reportsFilter]: any) => of(
          reports.filter((x: any) => this.filterMatch(x, reportsFilter)))),
      ),
      columns: combineLatest(
        of(this.allColumns),
        reports$,
      ).pipe(
        switchMap(([allColumns, reports]: any) =>
          reports.some((y: any) => this.canApprove(y) || this.canDiscard(y)) ?
            of(allColumns) :
            of(allColumns.filter((x: any) => x.name !== 'actions')),
        ),
      ),
      isReportsLoaded: watchAsLoadedObservable(this, 'reports'),
    });
  },
})
export default class TournamentReports extends Vue {
  public allColumns = [
    {name: 'report', title: 'report', width: '80%'},
    {name: 'confirmation', title: 'confirmation', width: '10%'},
    {name: 'actions', title: 'actions', width: '10%'},
  ];
  public columnClasses = [
    {name: 'report', class: 'tournament-report'},
  ];
  public reportsFilter = '';

  @Prop() public tournament!: number;
  @Prop() public lang!: string;
  @Prop() public heroesVersion!: number;

  public filterMatch(report: any, reportsFilter: string) {
    return filterMatchColumns(report, reportsFilter, [
      'report',
    ], {
      report: (x: string) => x.replace(/<(?:.|\n)*?>/gm, ''),
    });
  }

  public canDiscard(r: any) {
    return !r.isDiscarded && !!r.discardLink;
  }

  public canApprove(r: any) {
    return !r.isApproved && !r.isDiscarded && !!r.approveLink;
  }
}
